import { Table } from '@tanstack/react-table';
import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight } from 'lucide-react';

import { Button } from '@/components/ui/button';

interface DataTablePaginationProps<TData> {
  table: Table<TData>;
}

export function DataTablePagination<TData>({ table }: DataTablePaginationProps<TData>) {
  return (
    <div className='flex items-center justify-end'>
      <div className='flex items-center gap-2'>
        <div className='flex items-center justify-center text-sm font-medium text-[#EBEBEB99]'>
          <span>
            {table.getState().pagination.pageIndex + 1} of {table.getPageCount()}
          </span>
        </div>

        <Button
          variant='ghost'
          size='icon'
          className='size-4'
          onClick={() => table.previousPage()}
          disabled={!table.getCanPreviousPage()}
        >
          <span className='sr-only'>Go to previous page</span>
          <ChevronLeft />
        </Button>

        <Button
          variant='ghost'
          size='icon'
          className='size-5'
          onClick={() => table.nextPage()}
          disabled={!table.getCanNextPage()}
        >
          <span className='sr-only'>Go to next page</span>
          <ChevronRight />
        </Button>
      </div>
    </div>
  );
}
